import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import IdvSubmittedPage from './IdvSubmittedPage';

const IdvSubmittedRoute: FuseRouteItemType = {
  path: '',
  element: <IdvSubmittedPage />,
  auth: AUTH_ROLES.parent, // []
  children: [],
};

export default IdvSubmittedRoute;
